import {
  HIDE_SPINNER,
  HIDE_SPINNER_DESCUENTO,
  SET_DESCUENTO,
  SET_PAQUETE,
  SHOW_SPINNER,
  SHOW_SPINNER_DESCUENTO,
  SINGLE_COURSE_RECIBIDO,
  SET_PAYMENT_SOURCE,
  SET_DISCOUNT_CODE,
} from "../types";

export default (state, { type, payload }) => {
  switch (type) {
    case SET_PAQUETE:
      return { ...state, paquete: payload };
    case SET_DESCUENTO:
      return { ...state, descuento: payload, spinnerDescuento: false };
    case SHOW_SPINNER:
      return { ...state, spinner: true };
    case HIDE_SPINNER:
      return { ...state, spinner: false };
    case SHOW_SPINNER_DESCUENTO:
      return { ...state, spinnerDescuento: true };
    case HIDE_SPINNER_DESCUENTO:
      return { ...state, spinnerDescuento: false };
    case SINGLE_COURSE_RECIBIDO:
      return { ...state, course: payload };
    case SET_DISCOUNT_CODE:
      return { ...state, discountCode: payload };
    case SET_PAYMENT_SOURCE: {
      return { ...state, payment_source_id: payload };
    }
    default:
      return { ...state };
  }
};
